package one.healthium.insights.ui.models

import one.healthium.insights.domain.models.ActionModel
import one.healthium.insights.domain.models.SavedContentModel
import one.healthium.insights.domain.models.NabBarStyle
import one.healthium.insights.domain.models.NavbarModel
import androidx.compose.runtime.Immutable

@Immutable
data class NavBarUiModel(
    val model: NavbarModel,
    val savedContentModel: SavedContentModel?,
) {
    val title: String? = model.title
    val color: Long? = model.color
    val style: NabBarStyle = model.style
    val image: String? = model.image
    val actions: List<ActionModel>? = model.actions

    val isFavorite: Boolean = savedContentModel != null
}
